import { LocalStorage, date as dateUtils } from 'quasar'
let { addToDate } = dateUtils

const TOKEN_KEY = 'userToken'
const TOKEN_DEADTIME_KEY = 'tokenDeadtime'
const REMEMBER_KEY = 'rememberMeFlag'

export function getToken () {
  // let rememberFlag = LocalStorage.has(REMEMBER_KEY) ? getRememberFlag() : true
  // if (rememberFlag) {
  //   return LocalStorage.getItem(TOKEN_KEY)
  // } else {
  //   return SessionStorage.getItem(TOKEN_KEY)
  // }
  const deadtime = LocalStorage.getItem(TOKEN_DEADTIME_KEY)
  if (deadtime < Date.now()) {
    return removeToken()
  } else {
    return LocalStorage.getItem(TOKEN_KEY)
  }
}

export function setToken (token) {
  // let rememberFlag = LocalStorage.has(REMEMBER_KEY) ? getRememberFlag() : true
  // if (rememberFlag) {
  //   return LocalStorage.set(TOKEN_KEY, token)
  // } else {
  //   return SessionStorage.set(TOKEN_KEY, token)
  // }

  const rememberFlag = LocalStorage.has(REMEMBER_KEY) ? getRememberFlag() : true
  const tokenDeadtime = rememberFlag
    ? addToDate(new Date(), { days: 7 }).getTime()
    : addToDate(new Date(), { minutes: 30 }).getTime()

  if (!token) return removeToken()
  LocalStorage.set(TOKEN_DEADTIME_KEY, tokenDeadtime)
  return LocalStorage.set(TOKEN_KEY, token)
}

// export function refreshToken () {
//   const token = getToken()
//   setToken(token)
// }

export function removeToken () {
  // let rememberFlag = LocalStorage.has(REMEMBER_KEY) ? getRememberFlag() : true
  // if (rememberFlag) {
  //   return LocalStorage.remove(TOKEN_KEY)
  // } else {
  //   return SessionStorage.remove(TOKEN_KEY)
  // }

  LocalStorage.remove(TOKEN_DEADTIME_KEY)
  return LocalStorage.remove(TOKEN_KEY)
}

export function getRememberFlag () {
  return LocalStorage.getItem(REMEMBER_KEY)
}

export function setRememberFlag (val) {
  return LocalStorage.set(REMEMBER_KEY, val)
}

export function removeRememberFlag () {
  return LocalStorage.remove(REMEMBER_KEY)
}
